import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "whitespace-nowrap text-right" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-none pt-2 w-11" }, "From:", -1)
const _hoisted_5 = { class: "flex-grow pl-2" }
const _hoisted_6 = { class: "flex pt-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-none pt-2 w-11" }, "To:", -1)
const _hoisted_8 = { class: "flex-grow pl-2" }
const _hoisted_9 = { class: "pt-3" }
const _hoisted_10 = { class: "rounded-md shadow-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Autosuggest = _resolveComponent("Autosuggest")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Autosuggest, { ref: "fromAutosuggest" }, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Autosuggest, { ref: "toAutosuggest" }, null, 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "button-violet",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.searchClick && _ctx.searchClick(...args)))
          }, [
            _createVNode(_component_SearchIcon, { class: "h-5 w-5 text-white" })
          ])
        ])
      ])
    ])
  ]))
}